import { createSlice } from '@reduxjs/toolkit';
import { getUser, getAccessToken, setTokens, setUser, clearAuth } from '../utils/auth';

const initialState = {
  user: getUser(),
  isAuthenticated: !!getAccessToken(),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      const { user, tokens } = action.payload;
      state.user = user;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      setTokens(tokens.access, tokens.refresh);
      setUser(user);
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      clearAuth();
    },
    updateUser(state, action) {
      state.user = { ...state.user, ...action.payload };
      setUser(state.user);
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateUser, clearError } =
  authSlice.actions;
export default authSlice.reducer;
